import { Icon } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import MiniStatistics from '../../../components/card/MiniStatistics';
import IconBox from '../../../components/icons/IconBox';

type Props = {
    boxColor: string;
    brandColor: string;
    icon: IconType;
    name: string;
    value: string | number;
    isLoading?: boolean;
    /**
     * The read behind this number failed and there is nothing to show.
     * Forwarded to `MiniStatistics`, which renders its "unknown" pill where the
     * growth chip would go — the difference between a venue that took no
     * bookings and a venue whose booking count we were refused.
     */
    isError?: boolean;
};

export default function ImpactMetricCard({ boxColor, brandColor, icon, name, value, isLoading, isError }: Props) {
    return (
        <MiniStatistics
            startContent={
                <IconBox
                    w='56px'
                    h='56px'
                    bg={boxColor}
                    icon={<Icon w='32px' h='32px' as={icon} color={brandColor} />}
                />
            }
            name={name}
            value={value}
            isLoading={isLoading}
            isError={isError}
        />
    );
}
